import { useEffect, useState } from "react";

import { getMobileOperatingSystem, hRatio, triggerEvent } from "../../constants/utils";
import TextInput from "../../components/TextInput";
import ActionButton from "../../components/ActionButton";
import Styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import { useNavigate } from "react-router-dom";
import UserStore from "../../../stores/UserStore";
import Evolve from "../../icons/Evolve";

const isiOS = getMobileOperatingSystem() === "iOS";
const InputContainerStyle = {
  marginTop: 134 * hRatio,
  backgroundColor: "#f6f1e5",
};

const InputStyle = {
  backgroundColor: "#f6f1e5",
  height: isiOS ? 198 * hRatio : 172 * hRatio,
  fontSize: isiOS ? 69 * hRatio : 54 * hRatio,
};

const InputLabelStyle = {
  backgroundColor: "#f6f1e5",
  height: 48 * hRatio,
  fontSize: isiOS ? 48 * hRatio : 39 * hRatio,
};

const InputErrorStyle = {
  fontSize: isiOS ? 48 * hRatio : 39 * hRatio,
};

const SignUp = () => {
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
    name: "",
  });
  const [errors, setErrors] = useState({ email: null, password: null });
  // const isFormValid = formValues.password && formValues.email && !errors.email;
  const isFormValid = formValues.email && !errors.email;
  const navigate = useNavigate();

  const handlePasswordChange = (event) => {
    setFormValues((prev) => ({ ...prev, password: event.target.value }));
    UserStore.setFields("password", event.target.value);
  };

  //triggering event here
  useEffect(()=>{
    triggerEvent("Email_Signup_prctn");
  }, [])

  const handleNameChange = (event) => {
    setFormValues((prev) => ({ ...prev, name: event.target.value }));
    UserStore.setFields("name", event.target.value);
  };

  const handleEmailChange = (event) => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(event.target.value)) {
      setErrors((prev) => ({ ...prev, email: "Enter valid email address" }));
      UserStore.setFields("isEmailValid", false);
    } else {
      setErrors((prev) => ({ ...prev, email: "" }));
      UserStore.setFields("isEmailValid", true);
    }
    setFormValues((prev) => ({ ...prev, email: event.target.value }));
    UserStore.setFields("email", event.target.value);
    UserStore.setFields("password", "Evolve123");
  };

  const handleNavigation = () => {
    navigate("/premium");
    // navigate("/adhd/score_preparation");
    UserStore.createUserAccount();
  };

  return (
    <div className={Styles.SignUpBG}>
      <div className={Styles.EvolveIcon}>
        <Evolve />
      </div>
      <div style={{ height: 216 * hRatio }} />
      <p className={isiOS ? iStyles.SignUpTitle : Styles.SignUpTitle} style={{padding:'1rem'}}>
        {/* You are all set! */}
        Get your personalized procrastination routine!
      </p>
      <p className={isiOS ? iStyles.SignUpSubtitle : Styles.SignUpSubtitle}>
        {/* Complete your account to get started */}
        Enter your email address:
      </p>
      <img
        src={require("../../../assets/sign_up/sign_up.webp")}
        style={{
          height: "100%",
          width: "100%",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          position: "absolute",
          zIndex: -1,
        }}
      />
      <TextInput
        title={"your email *"}
        placeholder={"enter email"}
        style={InputContainerStyle}
        onChange={handleEmailChange}
        error={errors.email}
        type={"email"}
        inlineCustomStyle={` 
                    #email::placeholder { 
                        color: rgba(0, 0, 0, 0.63); 
                    }`}
        inputStyle={InputStyle}
        labelStyle={InputLabelStyle}
        errorStyle={InputErrorStyle}
      />
      
      <img
        src={require("../../../adhd_web_flow/images/cloud3.webp")}
        className={Styles.Cloud3}
      />
      <ActionButton
        text={"Get started"}
        disabled={!isFormValid}
        onClick={handleNavigation}
      />
    </div>
  );
};

export default SignUp;
